<template>

  <el-dialog v-model="dialogVisible" width="430" transition="bounce" append-to-body :close-on-click-modal="false"
             :close-on-press-escape="false" align-center z-index="9999">
    <div class="login-box">

      <div>

      </div>

      <div class="tab-logon-type">
        <el-row :gutter="20">
          <el-col :span="12">
            <div @click="handleClickTab(1)" :class="tabIndex===1?'tab-iten-select':'tab-item-un-select'">
              账户登录
            </div>
          </el-col>
          <el-col :span="12">
            <div @click="handleClickTab(2)" :class="tabIndex===2?'tab-iten-select':'tab-item-un-select'">
              手机登录
            </div>
          </el-col>
        </el-row>
      </div>


      <div v-if="tabIndex===1" class="login-form">
        <el-form label-position="right" size="large" ref="loginForm" :model="form" label-width="0">
          <el-form-item>
            <el-input v-model="form.username" clearable placeholder="请输入您的用户名"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 30px">
            <el-input v-model="form.password" type="password" clearable placeholder="请输入您的密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="isAgree" label="公开任务" :value="1">
              <template #default>
                <div style="margin-left: 5px;font-size: 12px">
                  阅读并同意 <a href="">《用户协议》</a> <a href="">《隐私协议》</a>
                </div>
              </template>
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button round type="primary" style="width: 100%">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="tabIndex===2" class="login-form">
        <el-form label-position="right" size="large" ref="phoneForm" :rules="phoneRules" :model="phoneForm"
                 label-width="0">
          <el-form-item prop="phone">
            <el-input v-model="phoneForm.phone" maxlength="11" minlength="11" :disabled="phoneCode.sendCode" clearable
                      placeholder="请输入您的手机号">
              <!--              <template #append>+ 8 6</template>-->
            </el-input>
            <span v-if="phoneCode.phoneError"> {{ phoneCode.phoneTip }}</span>
          </el-form-item>
          <el-form-item style="margin-top: 30px" prop="code">
            <el-input v-model="phoneForm.code" clearable placeholder="请输入短信验证码">
              <template #append>
                <el-button @click="handlerFettchCode" plain type="primary"
                           :disabled="phoneCode.sendCode">{{ phoneCode.text }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="isAgree" label="公开任务" :value="1">
              <template #default>
                <div style="margin-left: 5px;font-size: 12px">
                  阅读并同意 <a href="">《用户协议》</a> <a href="">《隐私协议》</a>
                </div>
              </template>
            </el-checkbox>
          </el-form-item>


          <el-form-item>
            <el-button round type="primary" :disabled="!phoneForm.login" :loading="phoneForm.loading"
                       @click="handlerPhoneLogin" style="width: 100%">
              <span v-if="!phoneForm.loading">验 证 码 登 录</span>
              <span v-else>登 录 中...</span>
            </el-button>
          </el-form-item>
        </el-form>
      </div>


    </div>


  </el-dialog>

</template>

<script>

import {getSmsCode} from "@/api/common";
import {userPhoneLogin} from "@/api/login";

export default {
  name: "LoginModal",
  data() {
    return {
      dialogVisible: false,
      isAgree: [1],
      tabIndex: 2,
      form: {
        username: '',
        password: '',
        code: '',
      },
      phoneForm: {
        phone: '',
        code: '',
        type: 1,
        login: false,
        loading: false,
      },
      phoneRules: {
        "phone": [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur'}
        ],
        "code": [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ]
      },
      phoneCode: {
        sendCode: false,
        text: "获取验证码",
        second: 120,
        timer: null,
        phoneTip: '',
        phoneError: false,
        codeTip: '',
        codeError: false
      },
    }
  },
  mounted() {
    console.log('LoginModal mounted')
    this.$bus.on('loginModal:open', this.handlerOpen)
    this.$bus.on('loginModal:close', this.handlerClose)
  },
  unmounted() {
    console.log('LoginModal unmounted')
    this.$bus.off('loginModal:open', this.handlerOpen)
    this.$bus.off('loginModal:close', this.handlerClose)
  },


  methods: {
    handleClickTab(e) {
      if (this.tabIndex !== e) {
        this.tabIndex = e
      }
    },
    handlerOpen() {
      console.log('打开登录弹窗')
      this.dialogVisible = true
    },
    handlerClose() {
      console.log('关闭登录弹窗')
      this.dialogVisible = false
    },

    handlerFettchCode() {
      if (!this.phoneForm.phone) {
        console.warn('用户未输入手机号，无法获取！')
        this.$modal.notice('请输入手机号码！', 'warning', '系统提示')
        return false;
      }
      //验证手机号格式
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.phoneForm.phone)) {
        console.warn('手机号格式错误！')
        this.$modal.notice('手机号格式错误！', 'warning', '系统提示')
        return false;
      }
      if (!this.phoneForm.sendCode) {
        this.$modal.loading('获取验证码中...')
        getSmsCode(this.phoneForm.phone, 1).then(res => {
          this.$modal.closeLoading()
          if (res && res.code === 200) {
            this.phoneForm.login = true
            this.phoneForm.phone = res.data.phone
            this.phoneForm.code = res.data.code
            this.$modal.notice("短信验证码已发送至手机：" + res.data.phone, 'success', '获取验证码成功')
            let second = 120
            if (res.data.expire >= 180) {
              second = res.data.expire - 180
            }
            this.handlerPhoneCode(second)
          } else {
            this.$modal.notice("获取验证码失败", 'error', '系统提示')
          }
        }).catch(error => {
          this.$modal.closeLoading()
          this.$modal.notice(error.message, 'error', '系统提示')
        })
      } else {
        this.$modal.notice("获取验证码频繁", 'warning', '系统提示')
      }
    },
    //设置验证码获取道及时间
    handlerPhoneCode(second) {
      this.phoneCode.sendCode = true
      this.phoneCode.text = second + " 秒"
      this.phoneCode.second = second
      this.phoneCode.timer = setInterval(() => {
        this.phoneCode.second--
        this.phoneCode.text = this.phoneCode.second + " 秒"
        if (this.phoneCode.second <= 0) {
          this.phoneCode.text = "重新获取"
          this.phoneCode.sendCode = false
          clearInterval(this.phoneCode.timer)
        }
      }, 1000)
    },
    //手机登录登录
    handlerPhoneLogin() {
      //
      this.$refs.phoneForm.validate(valid => {
        if (valid) {
          if (!this.isAgree.includes(1)) {
            this.$modal.alert('请阅读并同意平台协议', 'warning', '系统提示')
            return
          }
          this.phoneForm.loading = true
          this.phoneForm.type = 1
          this.$store.dispatch('user/phoneLogin', this.phoneForm).then(res => {
            console.log('手机登录成功:' + res)
            if (res.code === 200) {
              this.$store.dispatch('user/getUserInfo', res.data)
              this.handlerClose()
              if (res.data.type && res.data.type === 1) {
                this.$modal.notice('注册用户成功，账户为了您的账户安全，请尽快前往个人中心修改密码', 'success', '注册用户成功')
              } else {
                this.$modal.notice('登录成功', 'success', '系统提示')
              }
            }else {
              this.$modal.notice(res.message, 'error', '系统提示')
            }
          })
        }
      })
    }


  }
}
</script>

<style scoped>

.login-box {
  //min-height: 500px;
  padding-top: 30px;
  padding-bottom: 30px;


  .login-form {
    margin-top: 30px;
    padding: 0 50px;
  }


  .tab-logon-type {
    font-weight: 700;
    font-size: 18px;
    line-height: 40px;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    background: #F8F8F8;
    padding: 5px;
    margin: 0 50px;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;

    .tab-iten-select {
      background: #fff;
      color: #000;
      border-radius: 10px;
    }

    .tab-item-un-select {
      background: #F8F8F8;
      color: #828c99;
      border-radius: 10px;
    }

  }


}

::v-deep .el-input-group__append {
  background-color: #FFF;
  border: none;
  width: 70px;
}


</style>

<style>
.el-dialog {
  border-radius: 15px !important;

}
</style>